<script setup lang="ts">
const props = defineProps<{
  data: SectionStructuredTextRecord
  moduleIndex: number
}>()

const { level, isSemantic, invertedStyles } = useSectionRules(
  props.moduleIndex,
  props.data.invertColorTheme,
  !!props.data.title
)
</script>

<template>
  <div class="page-pt" :class="invertedStyles">
    <div class="container max-w-editor">
      <Heading
        v-if="data.title"
        :level="level"
        :is-semantic="isSemantic"
        :size="4"
        class="mb-4 lg:mb-8"
        >{{ data.title }}</Heading
      >
      <div v-if="data.subtitle" class="mb-8 lg:mb-10" v-html="data.subtitle" />
    </div>
    <DatoStructuredText
      v-if="data.structuredText"
      :data="data.structuredText"
      class="editor-full"
    />
  </div>
</template>
